export default __webpack_public_path__ + "static/media/available.c32ee62f.svg";